import React from 'react';

const IntTalentCaptureJobSearchSlot = () => <div data-x-marketing-slot="International job search int widget slot" />;

export default IntTalentCaptureJobSearchSlot;
